'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { loadWelloChat, type WelloChatBootOptions, whenWelloChatReady } from './index';
export type WelloChatProps = WelloChatBootOptions & {
  // 상담창 서버의 loader.js 주소
  src: string;
};

// 레이아웃에 한 번 둔다. 회원 토큰이 바뀌면 다시 부팅하고, 빠지면(언마운트) 상담창을 걷어낸다
export const WelloChat = t0 => {
  const $ = _c(8);
  const {
    src,
    memberToken: t1,
    hideLauncher: t2
  } = t0;
  const memberToken = t1 === undefined ? null : t1;
  const hideLauncher = t2 === undefined ? false : t2;
  let t3;
  let t4;
  if ($[0] !== hideLauncher || $[1] !== memberToken || $[2] !== src) {
    t3 = () => {
      let cancelled = false;
      loadWelloChat(src).then(chat => {
        if (!cancelled) {
          chat.boot({
            memberToken,
            hideLauncher
          });
        }
      }).catch(_temp);
      return () => {
        cancelled = true;
      };
    };
    t4 = [src, memberToken, hideLauncher];
    $[0] = hideLauncher;
    $[1] = memberToken;
    $[2] = src;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== src) {
    t5 = () => () => {
      loadWelloChat(src).then(_temp2).catch(_temp3);
    };
    t6 = [src];
    $[5] = src;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  return null;
};

// 사이트의 버튼·배지에서 상담창을 다룰 때. <WelloChat>이 화면 어딘가에 있어야 동작한다
export const useWelloChat = () => {
  const $ = _c(5);
  const [unread, setUnread] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let cancelled = false;
      let offs = [];
      whenWelloChatReady().then(chat => {
        if (cancelled) {
          return;
        }
        setIsOpen(chat.isOpen());
        offs = [chat.on("unread", count => setUnread(count ?? 0)), chat.on("open", () => setIsOpen(true)), chat.on("close", () => setIsOpen(false))];
      });
      return () => {
        cancelled = true;
        offs.forEach(_temp4);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isOpen || $[3] !== unread) {
    t2 = {
      unread,
      isOpen,
      open: _temp6,
      close: _temp8
    };
    $[2] = isOpen;
    $[3] = unread;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(error) {
  return reportError(error);
}
function _temp2(chat_0) {
  return chat_0.shutdown();
}
function _temp3() {}
function _temp4(off) {
  return off();
}
function _temp5(chat_0) {
  return chat_0.open();
}
function _temp6() {
  return void whenWelloChatReady().then(_temp5);
}
function _temp7(chat_1) {
  return chat_1.close();
}
function _temp8() {
  return void whenWelloChatReady().then(_temp7);
}